import { render, staticRenderFns } from "./UserGuides.vue?vue&type=template&id=6d61fa89"
import script from "./UserGuides.vue?vue&type=script&lang=js"
export * from "./UserGuides.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports